import React, { Component } from 'react';
import { connect } from 'react-redux';
import Aux from '../../hoc/Aux/Aux';
import classes from './Menu.css';
import Footer from '../../components/UI/Footer/Footer';
import RadioSelection from '../../components/RadioSelection/RadioSelection';
import { promotionsGet, promotionsSetEmpty, promotionSelect, bookingProcessSetStep } from '../../store/actions/bookingProcess';
import { BOOKING_STEPS, STEP_TITLES } from '../../constants';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';
import globalClasses from '../../App.css';

class Menu extends Component {
  async componentDidMount() {
    this.props.bookingProcessSetStep();
    if (
      this.props.areCurrentPromotionsValid && this.props.isPromotionsEmpty
    ) {
      return this.continueHandler(this.props.previousStep);
    }
    await this.props.getPromotions();
  }

  continueHandler = (from = null) => {
    if (from && from > BOOKING_STEPS.PROMOTION) {
      this.props.history.goBack();
    } else {
      this.props.history.push({
        pathname: '/dati-personali',
      });
    }
  }

  backHandler = () => {
    this.props.onBackStep();
    this.props.history.goBack();
  }

  handleOption = id => {
    console.log(id);
    this.props.onSelectMenu(id);
  }

  /**
   * On unmount reset the state of promotions empty to prevent errors if the users changes store
   */
  componentWillUnmount() {
    // this.props.resetPromotionsEmpty(false);
  }

  /**
   * Check if we need to skip this step because there are no promotions
   * @param {*} prevProps 
   */
  componentDidUpdate(prevProps) {
    if (
      !prevProps.areCurrentPromotionsValid && this.props.areCurrentPromotionsValid && this.props.isPromotionsEmpty
    ) {
      console.log('Menu, got valid promotions and empty');
      this.continueHandler();
    }
  }

  render() {
    let isRoom = true;

    if (this.props.availablePromotions) {
      for (let promotion of this.props.availablePromotions) {
        if (promotion.promotionPrice !== 0) {
          isRoom = false;
          break;
        }
      }
    }

    return (
      <Aux>
        <p className={globalClasses.PageTitle}>{isRoom ? this.props.translations.label_choose_room : this.props.translations.label_choose_menu}</p>
        <div className={classes.MainContainer}>
          {this.props.isFetchingPromotions ?
            <LogoLoader />
            :
            <RadioSelection
              options={this.props.availablePromotions}
              optionHandler={this.handleOption}
              selection={this.props.promotionSelected}
              translations={this.props.translations}
            />
          }
        </div>
        <Footer
          continueLbl={this.props.translations.label_continue}
          continueDisabled={this.props.isFetchingPromotions || !this.props.promotionSelected}
          backClick={this.backHandler}
          nextClick={this.continueHandler} />
      </Aux>
    )
  }
};

const mapStateToProps = state => {
  const { bookingProcessReducer } = state;
  return {
    availablePromotions: bookingProcessReducer.availablePromotions,
    isFetchingPromotions: bookingProcessReducer.isFetchingPromotions,
    isPromotionsEmpty: bookingProcessReducer.isPromotionsEmpty,
    promotionSelected: bookingProcessReducer.promotionSelected,
    areCurrentPromotionsValid: bookingProcessReducer.areCurrentPromotionsValid,
    previousStep: bookingProcessReducer.currentStep,
    translations: state.settingsReducer.translations,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getPromotions: () => dispatch(promotionsGet()),
    resetPromotionsEmpty: () => dispatch(promotionsSetEmpty(false)),
    onSelectMenu: promotion => dispatch(promotionSelect(promotion)),
    onNextStep: () => {},
    onBackStep: () => {},
    bookingProcessSetStep: () => dispatch(bookingProcessSetStep(BOOKING_STEPS.PROMOTION))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./src/containers/Menu/Menu.js